import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'Ndf', 
      path: '/ndf/:id', 
      component: require('@/components/Ndf').default
    },
    {
      name: 'Depense', 
      path: '/depense/:id', 
      component: require('@/components/Depense').default
    },
    { 
      name: 'Accueil', 
      path: '/', 
      component: require('@/components/Accueil').default
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js